"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var scheduling_history_html_1 = __importDefault(require("./scheduling-history.html"));
var scheduling_history_controller_1 = __importDefault(require("./scheduling-history.controller"));
function getInstructor(UsersModel, $stateParams) {
    return UsersModel.getInstructorByID($stateParams.instructorId);
}
getInstructor.$inject = ["UsersModel", "$stateParams"];
function getSchedulingHistory(UsersModel, $stateParams) {
    return UsersModel.getInstructorSchedulingHistory($stateParams.instructorId, {
        months: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
        ],
        year: 2022, //new Date(Date.now()).getFullYear()
    }).then(function (response) {
        return response.scheduling_history;
    });
}
getSchedulingHistory.$inject = ["UsersModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.admin.instructors.view.schedulinghistory', {
        'url': '/scheduling-history',
        'controller': scheduling_history_controller_1.default,
        'controllerAs': 'vm',
        'template': scheduling_history_html_1.default,
        resolve: {
            'instructor': getInstructor,
            'schedulingHistory': getSchedulingHistory
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default.module('admin.dashboard.instructors.view.schedulinghistory', []).config(config)
    .controller('AdminInstructorsViewSchedulingHistoryController', scheduling_history_controller_1.default);
